export const STATUSES = [
  { status: 'Pending', value: 1 },
  { status: 'In Progress', value: 5 },
  { status: 'Completed', value: 10 }
];
